export default {
  en: {
    PAGE_TITLE: 'Buyer Registration',
    LOADING_SETTINGS: 'Loading the Buyer Registration settings',
    
    INTRODUCTION: 'Introduction',
    ORP_FIELD_ENABLED_TT: 'The open registration URL is only active if it is enabled',
    ORP_FIELD_INTRODUCTION_TT: 'Brief introduction to the account participation rules that will be presented to the applicant during registration. Plain text only, no HTML markup.',
    ORP_FIELD_CONTACT: 'Contact email',
    ORP_FIELD_CONTACT_TT: 'Contact email for requests about the open registration for your account',
    ORP_FIELD_HAS_TERMS: 'Terms and Conditions',
    ORP_FIELD_HAS_TERMS_TT: 'If the registration page specifies Terms and Conditions, the applicant will be required to explicitly agree with them before proceeding with the registration',
    ORP_FIELD_TERMS_IS_URL: 'T&C hosted externally',
    ORP_FIELD_TERMS_IS_URL_TT: 'Speficies whether Terms and Conditions are available on external website via URL or embedded into the registration page as plain text.',
    ORP_FIELD_TERMS_URL: 'Terms and Conditions URL',
    ORP_FIELD_TERMS_URL_TT: 'URL of the externally hosted Terms And Conditions',
    ORP_FIELD_TERMS: 'Terms and Conditions Text',
    ORP_FIELD_TERMS_TT: 'Terms and Conditions in plain text, no HTML markup. The applicant will be required to agree to the specified Terms and Conditions before joining your account.',
    ORP_URL_TT: 'The URL that can be provided to applicants',
    ORP_URL: 'URL',
    BRP_SUCCESS_SAVE: 'The buyer registration settings has successfully been saved',

    // Publisher Registration translations
    PRP_SETTINGS_PAGE_TITLE: 'Publisher Registration',
    PRP_FIELD_CONTACT_TT: 'Contact email for requests about the publisher registration for your account',
    PRP_FIELD_CONTACT: 'Contact email',
    PRP_FIELD_DESCRIPTION_TT: 'Brief introduction to the account participation rules that will be presented to the publisher during registration. Plain text only, no HTML markup.',
    PRP_FIELD_DESCRIPTION: 'Introduction',
    PRP_FIELD_ENABLED_TT: 'The publisher registration URL is only active if publisher registration is enabled',
    PRP_FIELD_ENABLED: 'Public publisher registration enabled',
    PRP_FIELD_HAS_TERMS_TT: 'If the registration page specifies Terms and Conditions, the user will be required to explicitly agree with them before proceeding with the registration',
    PRP_FIELD_HAS_TERMS: 'Terms and Conditions',
    PRP_FIELD_TERMS_IS_URL_TT: 'Specifies whether Terms and Conditions are available on external website via URL or embedded into the registration page as plain text.',
    PRP_FIELD_TERMS_IS_URL: 'T&C hosted externally',
    PRP_FIELD_TERMS_TT: 'Terms and Conditions in plain text, no HTML markup. Publisher will be required to agree to the specified Terms and Conditions before joining your account.',
    PRP_FIELD_TERMS_URL_TT: 'URL of the externally hosted Terms And Conditions',
    PRP_FIELD_TERMS_URL: 'Terms and Conditions URL',
    PRP_FIELD_TERMS: 'Terms and Conditions Text',
    PRP_URL_TT: 'The URL that can be provided to publishers',
    PRP_URL: 'URL',
    PRP_SETTINGS_LOADING: 'Loading publisher registration settings',
    PRP_SETTINGS_SAVE: 'Save',
    PRP_SETTINGS_SAVE_SUCCESS: 'Saved Successfully',
    //errors
    FORM_VALIDATION_ERROR: 'Please fill out all required fields'
  }
};